import { adjustProjectDateForDisplay, adjustProjectDateForPersistence } from "@/lib/date-utils";

export function toDisplayProjectDate(value: string | Date | null | undefined): Date | null {
  return adjustProjectDateForDisplay(value);
}

export function toPersistedProjectDate(value: string | Date): string {
  return adjustProjectDateForPersistence(value).toISOString();
}
